import {RecordType} from '~/types/records/RecordType'
import {recordTypeToIndexSlug} from '~/lib/algoliaHelper'
import {GarbanzoConfig} from '~/types/globals/Garbanzo'
import {LessonRecord} from '~/types/records/LessonRecord'
import {PathRecord} from '~/types/records/PathRecord'

const {
  APP_BASE_URL,
}: GarbanzoConfig = window?.GARBANZO?.CONFIG || {}
/**
 * Get a URL for the Laravel app
 * @param path
 */
export const appUrl = (path: string): string => {
  path = path.startsWith('/') ? path : `/${path}`

  return new URL(path, APP_BASE_URL).toString()
}
/**
 * Get a URL for a lesson
 * @param lesson LessonRecord
 */
export const lessonUrl = (lesson: LessonRecord): string => `/lessons/${lesson.shortCode ?? lesson.uuid}`
/**
 * Get a URL for a path
 * @param path PathRecord
 */
export const pathUrl = (path: PathRecord): string => `/paths/${path.shortCode ?? path.uuid}`

/**
 * Permitted search URL params
 */
export interface SearchUrlParams {
  q?: string
  topicTags?: string[]
  themeTags?: string[]
  grammarTags?: string[]
  tenseTags?: string[]
}

export const encodeUrlParamValue = (str: string): string =>
  str.split(' ')
    .map(encodeURIComponent)
    .join('+')

export const decodeUrlParamValue = (str: string): string =>
  str.split('+')
    .map(decodeURIComponent)
    .join(' ')

/**
 * Get a URL for an Algolia search state
 */
export const searchUrl = (type: RecordType, params?: SearchUrlParams): string => {
  const url = new URL(`/${recordTypeToIndexSlug(type)}`, window.location.origin)
  Object.entries(params ?? new URLSearchParams()).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(value =>
        url.searchParams.append(
          key,
          encodeUrlParamValue(value.toString()),
        ),
      )
    } else {
      url.searchParams.append(key, encodeUrlParamValue(value.toString()))
    }
  })

  return url.toString()
}

/**
 * Check if a path has an equivalent in the Laravel app
 * @param path
 */
export const pathHasAppEquivalent = (path: string) => {
  return new URL(path, window.location.origin).pathname.match(/^\/(lessons|paths)/i)?.[0]
}
